import styled from "styled-components";

export const MAnnouncementDetailSection = styled.div`
  padding: 16px;
  width: 100%;
  height: 100%;
`;
